import { useState, useCallback } from "react";

import useText from "./useText";
import { getErrorMsg } from "../utills";
import { SOMETHING_WENT_WRONG } from "../../Payment/utils/constant";
import { GLOBAL_TEXT, REQUIRED_FIELD_TEXT, VALID_INPUT_TEXT } from "../GlobalConstant";

const useHandleForm = ({ formSchema = [], onSubmit, resetFields = true, defalutValues = {}, sendEvents }) => {
  const [values, setValues] = useState(defalutValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const opcoCurrency = process.env.REACT_APP_CURRENCY
  const { getText } = useText();

  const validate = useCallback((skipFieldName) => {
    const newErrors = {};
    formSchema.forEach(field => {
      const value = values[field.name];
      if (field.required && !value && field?.name !== skipFieldName) {
        newErrors[field.name] = getText(field?.errorMessage?.requiredErrMsg || REQUIRED_FIELD_TEXT);
      } else if (field.regex && value) {
        const regex = new RegExp(field.regex, "g");
        if (!regex.test(value)) {
          newErrors[field.name] = getText(field?.errorMessage?.regexError || VALID_INPUT_TEXT);
        }
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length > 0;
  }, [formSchema, values, getText]);

  const handleChange = useCallback((value, fieldData) => {
  
    const { name, currency, maxValue, minValue } = fieldData
    const { maxLengthError = undefined, regexError = undefined, minLengthError } = getErrorMsg(value, fieldData, maxValue, minValue);

    const globalErr = errors?.[GLOBAL_TEXT];
    const errMEsg = errors?.[name];

    if (globalErr || errMEsg) {
      const updatedError = { ...errors };
      globalErr && delete updatedError[GLOBAL_TEXT]
      errMEsg && delete updatedError[name]
      setErrors(updatedError)
    }

    setValues(prev => ({
      ...prev,
      [name]: value
    }));

    if (maxLengthError || regexError || minLengthError) {
      let errorMessage = regexError
      if (maxLengthError) {
        errorMessage = getText(maxLengthError, '', currency || opcoCurrency, maxValue)
      } else if (minLengthError) {
        errorMessage = getText(minLengthError, '', currency || opcoCurrency, minValue)
      }

      setErrors(prev => ({
        ...prev,
        [name]: getText(errorMessage)
      }))
    }

  }, [errors, getText]);


  const handleSubmit = useCallback(async (formData) => {
    if (validate()) return;

    setIsSubmitting(true);
    try {
      await onSubmit(values, formData);
      setSubmitted(true);
      resetFields && setValues({});
      setIsSubmitting(false);
    } catch (err) {
      setErrors({ global: err.message || SOMETHING_WENT_WRONG });
      setIsSubmitting(false);
    }
  }, [validate, values, onSubmit, resetFields]);

  const handleBlur = (value, field) => {
    const event = field?.event
    if (value && event) {
      sendEvents?.(event, { [field?.name]: value })
    }
  }

  return {
    values,
    errors,
    isSubmitting,
    submitted,
    handleChange,
    handleSubmit,
    handleBlur,
    validate
  };
};

export default useHandleForm;